export default new class Verbose {

    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('click', (el) => {

            // view__item clicked
            if (!el.target.matches(`.view__item`)) return;

            this.viewVerbose(el);
        });
    }

    viewVerbose(el) {

          // items container
          let container = document.querySelector(`.stocks__items`);
          let items = document.querySelectorAll(`.stocks__item`);
          //console.log(container.childNodes);

          // clear styles
          [...items].forEach((item) => {
              item.removeAttribute('style');
          });
      
          document.querySelectorAll(".menu-backdrop").forEach((el) => {
            el.remove();
          });
      
          // get current item
          let currentItem = el.target.closest(`.stocks__item`);
      
          // handle current item
          if(!currentItem.classList.contains('verbose')) {
            currentItem.classList.add('verbose');
      
            let top = 0,
                viewportOffset = container.getBoundingClientRect(),
                delta = viewportOffset.top * -1;
      
            if(delta > 0) {
              top = delta + 40
            } 
      
            currentItem.style.top = `${top}px`;
      
            this.backdrop();
            
          } else {
            currentItem.classList.remove('verbose');
          }
    }
      
    backdrop() {
        let elBackdrop = document.querySelector('.menu-backdrop');
      
        if(elBackdrop == null) {
          elBackdrop = document.createElement('div');
          elBackdrop.classList.add('menu-backdrop');
          document.body.appendChild(elBackdrop);
        }
    }
}